import { Button } from "@/ui/button";
import GradientBorderRadius from "@/ui/gradient-border-radius";
import Input from "@/ui/input";

export type TpSlValueEntity = {
  id?: string;
  tpSl: string;
  sellBalance: string;
};

export function isEmptyTpSlValues(items: TpSlValueEntity[]) {
  return items.every((item) => item.tpSl === "");
}

// TODO: Move this to a more suitable location, as it is something that is related to bot API integration
export function pairTpSlValues(items: TpSlValueEntity[]) {
  const tpSlPairs: [number | undefined, number | undefined][] = [];
  // TODO: Handle 0 values
  for (let i = 0; i < items.length; i++) {
    const current = Number(items[i].tpSl);
    if (i < items.length - 1) {
      const next = Number(items[i + 1].tpSl);
      if (current > 0 && next < 0) {
        tpSlPairs.push([current, Math.abs(next)]);
        i++; // skip the next element
      } else if (current < 0 && next > 0) {
        tpSlPairs.push([next, Math.abs(current)]);
        i++; // skip the next element
      } else if (current > 0) {
        tpSlPairs.push([current, undefined]);
      } else if (current < 0) {
        tpSlPairs.push([undefined, Math.abs(current)]);
      }
    } else {
      if (current > 0) {
        tpSlPairs.push([current, undefined]);
      } else if (current < 0) {
        tpSlPairs.push([undefined, Math.abs(current)]);
      }
    }
  }
  return tpSlPairs;
}

const TpSlGroupComponent = ({
  value,
  onChange,
}: {
  value: TpSlValueEntity[];
  onChange: (values: TpSlValueEntity[]) => void;
}) => {
  const handleAddTpSl: (
    index: number | null,
    tpSl?: string | null,
    sellBalance?: string | null
  ) => void = (index = null, tpSl = null, sellBalance = null) => {
    if (index == null) {
      return;
    }
    const newValues = [...value];
    if (tpSl != null) newValues[index].tpSl = tpSl;
    if (sellBalance != null) newValues[index].sellBalance = sellBalance;
    onChange(newValues);
  };

  const handleRemoveValueIndex = (index: number) => {
    const newValues = [...value];
    newValues.splice(index, 1);
    onChange(newValues);
  };

  const handleExpandValuesArray = () => {
    onChange([...value, { tpSl: "", sellBalance: "" }]);
  };

  const getLabel = (tpSl: string) => {
    let label = "TP/SL";
    if (!tpSl || Number.isNaN(Number(tpSl))) {
      return label;
    }
    if (Number(tpSl) > 0) {
      label = "TP";
    } else if (Number(tpSl) < 0) {
      label = "SL";
    }
    return label;
  };

  return (
    <>
      {value.map(({ tpSl, sellBalance }, index) => (
        <>
          <div className="col-span-1 text-xs font-semibold flex items-center">{`${getLabel(tpSl)}:`}</div>
          <div className="col-span-1 group h-[1.375rem]">
            <Input
              placeholder="Amount"
              value={tpSl}
              onChange={(v) => handleAddTpSl(index, v)}
              rightSide={
                <GradientBorderRadius
                  gradient={
                    tpSl && tpSl !== "" ? "reversed-100" : "default-border"
                  }
                  radius="left"
                  hover="input-50-right"
                  className="h-full w-[1.375rem]"
                >
                  <Input.Accordion className="text-xs">%</Input.Accordion>
                </GradientBorderRadius>
              }
            />
          </div>
          <div className="col-span-1 h-[1.375rem]">
            <div className="flex w-full gap-1 h-[1.375rem]">
              <div className="h-[1.375rem] group">
                <Input
                  placeholder="Sell Balance"
                  value={sellBalance}
                  onChange={(v) => handleAddTpSl(index, null, v)}
                  rightSide={
                    <GradientBorderRadius
                      gradient={
                        sellBalance && sellBalance !== ""
                          ? "reversed-100"
                          : "default-border"
                      }
                      radius="left"
                      hover="input-50-right"
                      className="h-full w-[1.375rem]"
                    >
                      <Input.Accordion className="text-xs">%</Input.Accordion>
                    </GradientBorderRadius>
                  }
                />
              </div>
              <div className="h-[1.375rem] flex items-center justify-center">
                <GradientBorderRadius
                  onClick={() => handleRemoveValueIndex(index)}
                  radius="circle"
                  hover="r-100"
                  gradient="default-border"
                  className="w-[1.375rem] h-[1.375rem] flex items-center justify-center text-xs"
                >
                  x
                </GradientBorderRadius>
              </div>
            </div>
          </div>
        </>
      ))}

      <div className="col-start-2 col-span-2">
        <Button
          active={false}
          title="+ Add TP/SL"
          radius="normal"
          className="text-xs w-full"
          onClick={handleExpandValuesArray}
        />
      </div>
    </>
  );
};

export default TpSlGroupComponent;
